import React from 'react';

const LevelGroupItem = ({ item, selectLevelGroup, selectArea, deselectArea }) => {
    console.log(item.level);
    return (
        <button onMouseOut={() => deselectArea()} onMouseEnter={() => selectArea(item.level)} className={ item.inactive === true ? 'residences--hotspot__sub-menu-item-inactive' : 'residences--hotspot__sub-menu-item' } onClick={ item.inactive ? () => {} : () => selectLevelGroup({ levelGroup: item.target }) }>{ item.level }</button>
    )
}

export default LevelGroupItem;